/** @deprecated Use @vp/common VPError when possible (supported by the server) */
export type VPError = {
  type: 'VPError';
  errors: string[];
};

/** @deprecated Use @vp/common VPError when possible (supported by the server) */
export const getNew = (errors: string[]): VPError => ({
  type: 'VPError',
  errors: [...errors],
});

/** @deprecated Use @vp/common VPError when possible (supported by the server) */
export const isVPError = (error: unknown): error is VPError =>
  typeof error === 'object' && error !== null && 'type' in error && error.type === 'VPError';
